/**
 @typedef OrderAdjustmentResource
 @type {Object}
 @property {function(object, object, function, function)} store
 */

const OrderAdjustmentResource = function (
    $resource,
    ApiRequestParams,
    AppConfig
) {
    return $resource(
        AppConfig.apiBaseUrl + 'orderadjustments',
        ApiRequestParams.defaults(),
        {
            store: {
                method: 'POST',
                url: AppConfig.apiBaseUrl + 'orderadjustments/:orderID'
            }
        }
    );
};

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = OrderAdjustmentResource;
}
